import axios from 'axios';
import { getApiBase } from './apiBase';

const API = getApiBase();

export const handoverVaultApi = {
  list(params = {}) {
    return axios.get(`${API}/handover-vault/items`, { params }).then((r) => r.data);
  },
  summary(params = {}) {
    return axios.get(`${API}/handover-vault/summary`, { params }).then((r) => r.data);
  },
  create(payload) {
    return axios.post(`${API}/handover-vault/items`, payload).then((r) => r.data);
  },
  update(id, payload) {
    return axios.patch(`${API}/handover-vault/items/${id}`, payload).then((r) => r.data);
  },
  archive(id) {
    return axios.delete(`${API}/handover-vault/items/${id}`).then((r) => r.data);
  },
};

export default handoverVaultApi;
